<template>
    <div class="bg-white border-16px p-3">
        <CCol sm="12">
            <h3 class="text-center custom-30px-600">Still Have Any Questions?</h3>
            <p class="custom-18px-400 text-center font-color-98A2B3">Then don’t hesitate to get in touch with us. We’ll help in any way we can.</p>
           
            <CCol sm="8" class="justify-content-center" style="width: 80%; margin: 0 auto;">
 <CRow>
    <CCol xs="12" sm="10">
    <CInput type="text" class="border-half"/>
  </CCol>
  <CCol xs="12" sm="2">
    <CButton class="bg-7F56D9 text-white border-half">Search</CButton>
  </CCol>
 </CRow>

</CCol>
              

            <CRow>
                <CCol sm="6">
                    <ToggleCard title="What is MyBoucer?">
                        MyBoucer is an initiative by MARA designed to provide financial support to eligible individuals for education and entrepreneurship purposes.
    
                    </ToggleCard>

                    <ToggleCard title="What types of financial reports are available in the dashboard?">
                        MyBoucer is an initiative by MARA designed to provide financial support to eligible individuals for education and entrepreneurship purposes.
    
                    </ToggleCard>

                    <ToggleCard title="What types of support does MyBoucer offer?">
                        MyBoucer is an initiative by MARA designed to provide financial support to eligible individuals for education and entrepreneurship purposes.
    
                    </ToggleCard>

                    <ToggleCard title="How do I set and track a budget using the dashboard?">
                        MyBoucer is an initiative by MARA designed to provide financial support to eligible individuals for education and entrepreneurship purposes.
    
                    </ToggleCard>
                    <ToggleCard title="What security measures are in place for the admin dashboard?">
                        MyBoucer is an initiative by MARA designed to provide financial support to eligible individuals for education and entrepreneurship purposes.
    
                    </ToggleCard>
                </CCol>
                <CCol sm="6">
                    <ToggleCard title="Can I generate reports through the admin dashboard?">
                        MyBoucer is an initiative by MARA designed to provide financial support to eligible individuals for education and entrepreneurship purposes.
    
                    </ToggleCard>

                    <ToggleCard title="What kind of notifications can be sent from the admin side?">
                        MyBoucer is an initiative by MARA designed to provide financial support to eligible individuals for education and entrepreneurship purposes.
    
                    </ToggleCard>

                    <ToggleCard title="Can the dashboard help with managing expenses?">
                        MyBoucer is an initiative by MARA designed to provide financial support to eligible individuals for education and entrepreneurship purposes.
    
                    </ToggleCard>

                    <ToggleCard title="How do I monitor profitability using the dashboard?">
                        MyBoucer is an initiative by MARA designed to provide financial support to eligible individuals for education and entrepreneurship purposes.
    
                    </ToggleCard>
                    
                </CCol>
            </CRow>
            <CCol sm="12" class="border-16px" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
                <CRow class="p-3">
                    <CCol sm="10">
                        <h3 class="custom-30px-600 text-white">Still Need Help?</h3>
                        <p class="text-white">We value your feedback and are here to assist you with any questions or concerns you may have. Whether you're seeking support, have inquiries about our services, or just want to share your thoughts, our dedicated team is ready to help. Your satisfaction is our priority, and we want to ensure that you receive the assistance you need.
<br />
Please don't hesitate to reach out to us through the Contact Us button, or you can connect with us via email or phone. We look forward to hearing from you!</p>
                    </CCol>
                    <CCol sm="2">
                        <CButton type="button" class="custom-bg-transparent text-white mt-5">Contact Us</CButton>
                    </CCol>
                </CRow>
            </CCol>
    
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";

import backgroundUrl from "../assets/image/bgPurple.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'

import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import ToggleCard from '../components/Toggle.vue';

export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartBar,
        VueCal,
        ToggleCard

    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            isPopupVisible2: false,
            list: [],
            user: {},
            isPopupVisible3: false,
            videoUrl: '',
            searchQuery: '',
            defaultDatasets: [{
                label: 'Candidate',
                backgroundColor: ['#928AFD', '#F2F1FF'],
                data: [40, 20]
            }],
            defaultDatasets1: [{
                    label: 'Tech',
                    backgroundColor: '#FC7D5D',
                    borderColor: '#FC7D5D',
                    borderWidth: 1,
                    data: [15, 20, 30, 40] // Values for each month
                },
                {
                    label: 'Designer',
                    backgroundColor: '#229E88',
                    borderColor: '#229E88',
                    borderWidth: 1,
                    data: [15, 25, 35, 45] // Values for each month
                },
                {
                    label: 'Marketing',
                    backgroundColor: '#F7CC0E',
                    borderColor: '#F7CC0E',
                    borderWidth: 1,
                    data: [24, 20, 10, 15] // Values for each month
                },
                // Add more datasets as needed
            ],
            chartOptions1: {
                scales: {
                    yAxes: [{
                        gridLines: {
                            display: false // Hide y-axis grid lines
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false // Hide x-axis grid lines
                        }
                    }]
                }
            },
            chartOptions: {

            },
            chartCandidate: {},
            selectedCandidate: {},
            scaleMarks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            category: [],
            customLocale: {
                days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], // Abbreviated day names
                months: [
                    'January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'
                ],
                firstDayOfWeek: 1, // Set Monday as the first day of the week
            },
        }





    },
    async mounted() {
        // try {
        //     const isAuth = await this.UserAuth();
        //     if (isAuth) {

        //         this.GetDetailTotalCandidate();
        //         this.GetTotalCandidate();
        //         this.GetValueCategoryChart();
        //     } else {
        //         this.GoToPage();
        //     }
        // } catch (error) {
        //     this.GoToPage();
        //     console.error("Error during authentication:", error);
        //     // Handle the error here
        // }

    },

    computed: {
        filteredList() {
            const query = this.searchQuery.toLowerCase().trim();
            if (!query) {
                return this.list;
            } else {
                return this.list.filter(item => {
                    // Adjust the condition based on your search criteria
                    return item.name.toLowerCase().includes(query);
                });
            }
        },

    },

    methods: {



    }

};
</script>